import { Box, Link, Typography } from '@mui/material';
import React, { ReactNode } from 'react';
import sideBg from './../../assets/img/login-side-background.png';
import { ReactComponent as ViprLogo } from '../../assets/icons/logo/icon.svg';
import { ReactComponent as ViprText } from '../../assets/icons/logo/text.svg';

type LoginContainerProps = {
  children: ReactNode;
};

const LoginContainer = (props: LoginContainerProps) => {
  return <Box
    display={'flex'}
    width={'100%'}
    height={'100%'}
    bgcolor={'#000000'}
    position={'relative'}
    style={{
      overflowY: 'auto',
    }}
  >
    <Box position={'absolute'}
      width={'58%'}
      left={'-16%'}
      top={'-13%'}
      sx={{
        aspectRatio: '2.5',
        borderRadius: '58%',
        opacity: '0.4',
        background: 'rgba(93, 117, 151, 1)',
        filter: 'blur(200px)',
      }}
      zIndex={0}
    >

    </Box>
    <Box flex={55}
      zIndex={1}
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        flex={1}
        gap={'80px'}
        width={'55%'}
        minWidth={'fit-content'}
        maxWidth={'440px'}
        justifyContent={'center'}>
        <Box>
          <ViprLogo width={'36px'} height={'36px'}/>
        </Box>
        <Box padding={'48px 0px'}>
          {props.children}
        </Box>
      </Box>
      <Box display={'flex'}
        height={'100px'}
        width={'100%'}
        padding={'10px 40px'}
        alignItems={'center'}>
        <Typography variant='tsm' color={(t) => t.palette.grey[500]}>© VIPR.ai 2025</Typography>
      </Box>
    </Box>
    <Box flex={45}
      zIndex={1}
      height={'100%'}
      display={'flex'}
      padding={'20px 20px 20px 0px'}
      color={(t) => t.palette.base.bodyText}>
      <Box
        border={'1px solid #FFFFFF33'}
        overflow={'clip'}
        height={'100%'}
        display={'flex'}
        width={'100%'}
        sx={{
          background: `url(${sideBg})`,
          backgroundSize: 'cover',
          borderRadius: '12px',
          backgroundClip: 'padding-box',
        }}
        position={'relative'}
      >
        <Box position={'relative'}
          width={'100%'}
          height={'100%'}
          sx={{
            background: 'linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 50%, #000 100%)',
          }}
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'space-between'}>

          <Box display={'flex'} flexDirection={'column'}>
            <Box display={'flex'}
              alignItems={'center'}
              padding={'40px'}
              gap={'16px'}>
              <ViprLogo/>
              <ViprText/>
            </Box>
            <Box display={'flex'}
              flexDirection={'column'}
              padding={'0px 80px 40px'}
              gap={'6px'}>
              <Typography variant='dsm'
                fontWeight={600}>Scan. Search. Solve.™</Typography>
              <Typography variant='dxs'
                lineHeight={'30px'}
                sx={{
                  opacity: '0.7',
                }}>Detect more and prevent more with vehicle intelligence</Typography>
            </Box>
          </Box>

          <Box>
            <Box display={'flex'}
              flexDirection={'column'}
              padding={'40px'}
              gap={'4px'}>
              <Typography variant='tsm' fontWeight={500}>Experiencing issues?</Typography>
              <Typography
                variant='tsm'
                fontWeight={500}>Get assistance via <Link href='mailto:support@vipr.ai'
                  sx={{
                    color: (t) => t.palette.base.bodyText,
                    textDecoration: 'underline',
                  }}>support@vipr.ai</Link>
              </Typography>
            </Box>
          </Box>

        </Box>
      </Box>
    </Box>
  </Box>;
};

export default LoginContainer;
